/* tslint:disable */
/* eslint-disable */
/**
 * DigiB Core Read API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum AccountNoteStatus {
    Open = 'Open',
    Cancelled = 'Cancelled',
    Paid = 'Paid',
    PaidOnline = 'PaidOnline',
    ProcessingPayment = 'ProcessingPayment'
}



